<div class="date-range-chooser-component" [class.date-range-chooser-component--compact]="compact">
  <mat-form-field class="date-range-field" appearance="outline" [matMenuTriggerFor]="preselectedDatesMenu">
    <div class="date-range-field-preselected" [hidden]="!preselectedDate">
      <span>{{ preselectedDate | translate }}</span>
    </div>
    <!-- <mat-label [hidden]='!isPreselectedDate'>{{'dateRange.label' | translate}}</mat-label> -->
    <div [hidden]="preselectedDate">
      <mat-date-range-input [formGroup]="rangeFormGroup" [rangePicker]="picker" [comparisonStart]="getComparisonStart" [comparisonEnd]="getComparisonEnd">
        <input matStartDate (dateChange)="preselectedDate = ''" placeholder="Start date" formControlName="start" />
        <input matEndDate (dateChange)="preselectedDate = ''" placeholder="End date" formControlName="end" />
      </mat-date-range-input>
    </div>

    <mat-icon class="preselected-dates" matSuffix>arrow_drop_down</mat-icon>
  </mat-form-field>

  <mat-menu #preselectedDatesMenu="matMenu" class="date-range-menu">
    @if (!skipLifetime) {
      <button mat-menu-item (click)="setPreselectedDate(999, 'dateRange.lifetime')">
        <span>{{ "dateRange.lifetime" | translate }}</span>
      </button>
    }
    <button mat-menu-item (click)="setPreselectedDate(7, 'dateRange.last7days')">
      <span>{{ "dateRange.last7days" | translate }}</span>
    </button>
    <button mat-menu-item (click)="setPreselectedDate(30, 'dateRange.last30days')">
      <span>{{ "dateRange.last30days" | translate }}</span>
    </button>
    <button mat-menu-item (click)="setPreselectedDate(90, 'dateRange.last90days')">
      <span>{{ "dateRange.last90days" | translate }}</span>
    </button>
    <button mat-menu-item (click)="setPreselectedDate(1, 'dateRange.lastMonth')">
      <span>{{ "dateRange.lastMonth" | translate }}</span>
    </button>
    @if (allTimeStartDate) {
      <button mat-menu-item (click)="setAllTime()">
        <span>{{ "dateRange.allTime" | translate }}</span>
      </button>
    }
    <button mat-menu-item (click)="picker.open()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <span class="text-select-dates">{{ "search.dateRange" | translate }}</span>
    </button>
  </mat-menu>
</div>
